import { Link } from 'react-router-dom'
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa'
import styles from './Footer.module.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.footerContainer}`}>
        <div className={styles.footerGrid}>
          {/* Over */}
          <div className={styles.footerSection}>
            <h3>Sobé Zorg Twente</h3>
            <p>
              Warme en inclusieve dagbesteding voor ouderen, waar welzijn en plezier centraal staan.
            </p>
          </div>

          {/* Links */}
          <div className={styles.footerSection}>
            <h4>Snelle Links</h4>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/over-ons">Over ons</Link></li>
              <li><Link to="/diensten">Diensten</Link></li>
              <li><Link to="/werk-en-leren">Werk & Leren</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/privacy">Privacy</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className={styles.footerSection}>
            <h4>Contact</h4>
            <ul className={styles.contactList}>
              <li>
                <FaEnvelope aria-hidden="true" />
                <a href="mailto:info@sobe-zorg.nl">info@sobe-zorg.nl</a>
              </li>
              <li>
                <FaMapMarkerAlt aria-hidden="true" />
                <span>Herinckhavestraat 1<br />7557 JJ Hengelo</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div className={styles.footerSection}>
            <h4>Volg ons</h4>
            <div className={styles.socialLinks}>
              <a href="https://facebook.com" aria-label="Bezoek onze Facebook pagina" target="_blank" rel="noopener noreferrer">
                <FaFacebook aria-hidden="true" />
              </a>
              <a href="https://instagram.com" aria-label="Bezoek onze Instagram pagina" target="_blank" rel="noopener noreferrer">
                <FaInstagram aria-hidden="true" />
              </a>
              <a href="https://linkedin.com" aria-label="Bezoek onze LinkedIn pagina" target="_blank" rel="noopener noreferrer">
                <FaLinkedin aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <p>&copy; {currentYear} Sobé Zorg Twente. Alle rechten voorbehouden.</p>
          <p>
            <Link to="/privacy">Privacy & Cookies</Link>
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
